import React from "react";
import "./ReplikitFeatured.css";
import LazyDemoVideo from "./LazyDemoVideo";
import replikitDemo from "../assets/Replikit.mp4";

function ReplikitFeatured() {
  return (
    <section id="replikit" className="replikit-featured section">
      <div className="container">
        <h2>Replikit: Classroom Python Labs in the Browser</h2>
        <LazyDemoVideo
          src={replikitDemo}
          label="Replikit browser-based Python IDE demo"
          className="replikit-hero-image"
          width={1756}
          height={1038}
        />

        <div className="replikit-featured-content">
          <p>
            Replikit started as a practical answer to a classroom problem:
            teaching Python in environments where students may not have install
            permissions, consistent machines, or reliable local setup time. It
            has grown into a browser-based lab platform where learners can open
            a Python workspace, run code in a managed environment, save their
            work, and keep moving without fighting their computer first.
          </p>
          <p>
            The current build is focused on making Replikit useful for actual
            instruction, not just solo experimentation. Labs can be forked into
            student-owned workspaces, classrooms give an instructor a place to
            organize cohorts and assignments, and invite flows make it possible
            to bring students into the right learning space without manual
            account wrangling.
          </p>

          <div
            className="replikit-status-grid"
            aria-label="Current Replikit project capabilities"
          >
            <article className="replikit-status-card">
              <h3>Forkable Labs</h3>
              <p>
                Starter exercises and examples can become individual student
                copies, giving each learner a safe place to experiment while
                preserving the original lab.
              </p>
            </article>
            <article className="replikit-status-card">
              <h3>Classroom Admin</h3>
              <p>
                Classroom-oriented admin tools help structure cohorts, organize
                lab access, and support the repeated setup teachers need across
                multiple sessions.
              </p>
            </article>
            <article className="replikit-status-card">
              <h3>Invite Workflow</h3>
              <p>
                Invitation flows connect students to the right classroom or lab
                context, reducing the friction that usually shows up before the
                first line of Python is written.
              </p>
            </article>
            <article className="replikit-status-card">
              <h3>Managed Runtime</h3>
              <p>
                Python code runs in separated, managed environments, giving
                each student a reproducible runtime without local installs and
                keeping execution consistent across browsers and machines.
              </p>
            </article>
          </div>

          <h3>Why I Built It This Way</h3>
          <p>
            A lot of browser coding tools are aimed at general-purpose editing,
            monetized sandboxes, or AI-first workflows. Replikit is intentionally
            more teaching-shaped: fast to join, clear enough for beginners, and
            built around the fundamentals of writing and running Python. The
            system is organized around classroom jobs like joining a cohort,
            forking a lab, saving workspace state, and running code in
            reproducible managed environments. At a small-classroom scale,
            supporting more users can start with giving the runtime host more
            capacity instead of changing how students join or work.
          </p>
          <p>
            As a portfolio project, Replikit shows the full product loop I care
            about: identifying a real user constraint, designing a workflow for
            teachers and students, and tying together frontend engineering,
            cloud services, authentication, persistence, and managed code
            execution into one usable system.
          </p>
        </div>

        <div className="replikit-links">
          <h3>
            <a
              href="https://replikit.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              Live Website: www.replikit.io
            </a>
          </h3>
        </div>
      </div>
    </section>
  );
}

export default ReplikitFeatured;
